export default __webpack_public_path__ + "static/media/Mask Group 6@2x.698c522a.png";